import React from "react";
import {
  COMMUNITY_BADGE,
  COMMUNITY_TITLE,
  COMMUNITY_DESCRIPTION,
  WHATSAPP_CTA_LABEL,
  FOOTER_INFO_TEXT,
  COMMUNITY_PERKS,
} from "./ReferrersCommunity.constants";
import { useReferrersCommunity } from "./useReferrersCommunity";
import { WhatsAppIcon } from "./WhatsAppIcon";
import { REFERRERS_COMMUNITY_PROPS } from "./ReferrersCommunity.types";

export const ReferrersCommunity = ({ whatsappCommunityUrl }) => {
  const { handleJoinCommunity } = useReferrersCommunity(whatsappCommunityUrl);

  return (
    <section className="tw-py-8">
      <div
        style={{
          backgroundColor: "#EAFBF1",
          borderRadius: "28px",
          padding: "clamp(28px, 4vw, 44px)",
        }}
        className="tw-mx-auto tw-border tw-border-solid tw-border-[#D7F5E3] tw-grid tw-grid-cols-1 md:tw-grid-cols-12 tw-gap-8 md:tw-gap-10 tw-items-center"
      >
        {/* Left Content Column */}
        <div className="md:tw-col-span-6 tw-flex tw-flex-col tw-gap-6 tw-justify-between">
          <div>
            <div className="tw-text-xs tw-font-bold tw-tracking-wider tw-text-[#198754] tw-uppercase tw-mb-3">
              {COMMUNITY_BADGE}
            </div>
            <h2 className="tw-text-2xl sm:tw-text-3xl tw-font-extrabold tw-text-slate-900 tw-leading-tight tw-m-0 tw-mb-4">
              {COMMUNITY_TITLE}
            </h2>
            <p className="tw-text-sm sm:tw-text-base tw-text-slate-600 tw-leading-relaxed tw-m-0 tw-mb-6">
              {COMMUNITY_DESCRIPTION}
            </p>
          </div>

          <div>
            <button
              type="button"
              onClick={handleJoinCommunity}
              className="tw-inline-flex tw-items-center tw-justify-center tw-gap-2.5 tw-bg-[#22C55E] hover:tw-bg-[#16A34A] tw-text-white tw-font-bold tw-text-sm sm:tw-text-base tw-px-6 tw-py-3.5 tw-rounded-xl tw-border-0 tw-cursor-pointer tw-transition-colors tw-shadow-sm"
            >
              <WhatsAppIcon />
              <span>{WHATSAPP_CTA_LABEL}</span>
            </button>
            <div className="tw-text-xs tw-text-slate-500 tw-mt-3 tw-font-normal">
              {FOOTER_INFO_TEXT}
            </div>
          </div>
        </div>

        {/* Right 2x2 Feature Cards Grid */}
        <div className="md:tw-col-span-6 tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 md:tw-grid-cols-2 tw-gap-3.5">
          {COMMUNITY_PERKS.map((perk) => (
            <div
              key={perk.id}
              className="tw-bg-white tw-p-4 tw-rounded-2xl tw-border tw-border-solid tw-border-emerald-100 tw-shadow-sm tw-flex tw-flex-col tw-justify-between"
            >
              <div className="tw-font-bold tw-text-slate-900 tw-text-sm tw-mb-1.5">
                {perk.title}
              </div>
              <div className="tw-text-xs tw-text-slate-500 tw-leading-relaxed">
                {perk.description}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

ReferrersCommunity.propTypes = REFERRERS_COMMUNITY_PROPS;

ReferrersCommunity.defaultProps = {
  whatsappCommunityUrl: null,
};
